function showImage(index) {
  const items = document.querySelectorAll('.quick-buy-modal__gallery-wrapper .product-gallery .product-gallery__media');
  const container = document.querySelector('.quick-buy-modal__gallery-wrapper .product-gallery__carousel');

  if (items[index]) {
    container.scrollTo({
      left: items[index].offsetLeft,
      behavior: 'smooth'
    });
  }
}

async function getShopifyCart() {
  const response = await fetch("/cart.js");
  const data = await response.json();
  return data;
}

async function getShopifySection(section_name) {
  const url = `/?sections=${section_name}`
  const response = await fetch(url);
  const data = await response.json();
  return data;
}

function appendShippingInfoIfMissing() {
  $('td.text-center.shipping_delivery_rr').each(function () {
    var htmll = $(this).html();

    // Check if the previous td doesn't already have the specific element/content
    if ($(this).prev('td.main_data_holder').find('.line_item').length === 0) {
      $(this).prev('td.main_data_holder').append(htmll);
    }
  });
}


async function updateCartHTML() {
  const resp = await getShopifySection("main-cart");

  const parsedHTML = new DOMParser().parseFromString(resp['main-cart'], 'text/html');

  parsedHTML.querySelectorAll("line-item-quantity.h-stack.gap-4").forEach(el => el.remove());

  const shippingEstimator = parsedHTML.querySelector("shipping-estimator");
  if (shippingEstimator) shippingEstimator.remove();

  const newCartContent = parsedHTML.querySelector(".cart-page");
  if (newCartContent) {
    document.querySelector(".cart-page").innerHTML = newCartContent.innerHTML;
    if (window.matchMedia("(max-width: 767px)").matches) {
    appendShippingInfoIfMissing();
  }
  }
}


async function clearCart() {
  const response = await fetch("/cart/clear.js");
  const data = await response.json();
  return data;
}

async function addToCart(items) {
  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(items),
  });
  return response.json();
}

function setLocalStorage(key, value) {
  const serialized = JSON.stringify(value);
  localStorage.setItem(key, serialized);
}

function getLocalStorage(key) {
  const serialized = localStorage.getItem(key);
  return serialized ? JSON.parse(serialized) : null;
}


function addLoaderinCartDrawer()
{
  const submitButton = document.querySelector(".cart-drawer__footer [type='submit']");

  if (submitButton && !submitButton.querySelector(".loader-01")) {
    const loaderDiv = document.createElement("div");
    loaderDiv.className = "loader-01";
    submitButton.append(loaderDiv);
  }
}

function addLoaderInCartPage() {
  const checkoutButton = document.querySelector(".cart-footer [name='checkout']");
  
  if (checkoutButton && !checkoutButton.querySelector(".loader-01")) {
    // Clear all existing content
    checkoutButton.textContent = "";

    // Create span for "Checkout" text
    const span = document.createElement("span");
    span.className = "loadeur-span-text"; 
    span.innerText = "Checkout";  // Capitalize if needed
    checkoutButton.appendChild(span);

    // Create loader div
    const loaderDiv = document.createElement("div");
    loaderDiv.className = "loader-01"; 
    checkoutButton.appendChild(loaderDiv);
  }
}



setInterval(() => {
  addLoaderInCartPage();
  addLoaderinCartDrawer();
}, 1000);

$(document).on("submit", "form.cart-drawer__footer", async function (event) {
  event.preventDefault();
  event.stopImmediatePropagation();

  $(this).find('button[name="checkout"]').addClass("loaderr-active");
  $(this).find('button[name="checkout"]').css("color", "white");

  window.location.href = "/checkout";
});

function getVariantsArray(element_selector) {
  const nodes = document.querySelectorAll(element_selector);

  const variants = Array.from(nodes).map((el) => {
    const id = el.getAttribute("data-id");
    const quantity = el.getAttribute("data-qrt");
    const title = el.getAttribute("variant-title");

    if (!title) return null;

    const parts = title.split("/").map(v => v.trim());

    let style = null;
    let size = null;
    let material = null;

    // -------------------------------------
    // STRICT LOGIC (from first function)
    // -------------------------------------

    // 3 PARTS → style / size / material
    if (parts.length === 3) {
      style = parts[0];
      size = parts[1];
      material = parts[2];
    }
    // 2 PARTS → size / material
    else if (parts.length === 2) {
      size = parts[0];
      material = parts[1];
    }
    // -------------------------------------
    // DYNAMIC LOGIC (from second function)
    // Only used when strict logic does not apply
    // -------------------------------------
    else {
      // 1 PART → treat as material only
      if (parts.length === 1) {
        material = parts[0];
      }
      // >3 PARTS → 1st=style, 2nd=size, rest=material
      else if (parts.length > 3) {
        style = parts[0] || null;
        size = parts[1] || null;
        material = parts.slice(2).join(" / ") || null;
      }
    }

    // ensure size is parsed
    if (size && !isNaN(size)) size = parseInt(size);

    const finalTitle = style
      ? `${style} / ${size ?? ''} / ${material ?? ''}`.trim()
      : `${size ?? ''} / ${material ?? ''}`.trim();

    return { id, quantity, style, size, material, title: finalTitle };
  }).filter(Boolean);


  // ORDERING
  const styleOrder = [...new Set(variants.map(v => v.style).filter(Boolean))];
  const materialOrder = [...new Set(variants.map(v => v.material))];

  variants.sort((a, b) => {
    if (a.style !== b.style) {
      if (!a.style) return 1;
      if (!b.style) return -1;
      return styleOrder.indexOf(a.style) - styleOrder.indexOf(b.style);
    }

    if (a.material !== b.material) {
      return materialOrder.indexOf(a.material) - materialOrder.indexOf(b.material);
    }

    return (a.size || 0) - (b.size || 0);
  });

  return variants.map(({ id, quantity, title }) => ({
    id,
    quantity,
    title
  }));
}


function setSequence() {
  if (new URLSearchParams(window.location.search).has('variant')) {
    return;
  }

  const variants = getVariantsArray(".variatnt-priceee");

  for (let index = 0; index < variants.length; index++) {
    const variant = variants[index];

    if (Number(variant.quantity) > 0) {
      const parts = variant.title.split("/").map(v => v.trim());
      parts.forEach(value => {
        const label = document.querySelector(`.product-info variant-picker .block-swatch[data-value="${value}"]`);
        if (label) {
          label.classList.remove("is-disabled");
          label.click();
        }
      });
      break;
    }
  }
  // setThePriceOfBundle();
}

function setThePriceOfBundle() {
  const variant_id = ShopifyAnalytics.meta.selectedVariantId;
  const variants = ShopifyAnalytics.meta.product.variants;

  const price = variants.find(v => v.id == variant_id)?.price / 100;
  if (!price) return;

  const priceContainer = document.querySelector(".product-info sale-price.text-subdued");
  const oldPrice = priceContainer?.querySelector(".money.buckscc-converted.buckscc-money");

  oldPrice.remove();
  priceContainer.insertAdjacentHTML("beforeend", `<span class="money">${price} AED</span>`);
}


setTimeout(() => {
  setSequence();
}, 1000);



function setQuickViewSequence() {
  const variants = getVariantsArray("quick-buy-modal .current_variantss .variatnt-priceeess");

  for (const variant of variants) {
    if (Number(variant.quantity) > 0) {
      const parts = variant.title.split("/").map(v => v.trim());

      parts.forEach(value => {
        if( value == "Gold Platted Silver"){
          value = "18k Gold Plated";
        }

        const label = document.querySelector(`quick-buy-modal .product-info variant-picker .block-swatch[data-value="${value}"]`);
        if (label) {
          label.classList.remove("is-disabled");
          label.click();
        }

      });

      break;
    }
  }
}


$(document).on("click", ".product-card__quick-add-button", function () {
    setTimeout(function () {
        setQuickViewSequence();
    }, 2000);
});
